import { AddressType } from '@mp/organization-master-data/addresses/domain';

export const ADDRESS_TYPES_PRIORITY_ORDER = [
  AddressType.MainAddress,
  AddressType.DefaultDeliveryAddress,
  AddressType.DefaultBillingAddress,
  AddressType.DeliveryAddress,
  AddressType.BillingAddress,
];
